import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthWrapper from "./Auth";
import { supabase } from "../supabaseClient";
import "./auth.css";

/**
 * 🔒 IMPORTANT
 * Affiliate params ko component ke bahar lock kiya gaya hai
 * taake login/signup tab switch par reset na hon
 */
const AFFILIATE_PARAMS = (() => {
  const p = new URLSearchParams(window.location.search);
  return {
    ref: p.get("ref"),   // aff_xxx
    type: p.get("type") // revenue | turnover
  };
})();

export default function Signup() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  // ❌ kuch bhi change nahi kiya
  const defaultUserData = {
    balance: 0,
    total_invested: 0,
    todays_profit: 0,
    total_payout: 0,
    monthly_profit: 0,
    pending_profits: [],
    daily_profit_rate: 0,
    reward_balance: 0,
    withdraw_limit_today: 0,
    next_profit_time: null,
    last_package_date: null,
    last_login: new Date().toISOString(),
    deposit_history: [],
    withdraw_history: [],
    transactions: [],
    earn_system: {},
    earn_history: [],
    active_package: {},
    settings: {},
    avatar_url: null
  };

  const handleSignup = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      alert("Email aur password lazmi hai.");
      return;
    }

    // ================= SIGNUP =================
    const { data, error } = await supabase.auth.signUp({
      email,
      password
    });

    if (error) {
      alert(error.message);
      return;
    }

    const userId = data.user?.id || data.session?.user?.id;

    // email verification ON case
    if (!userId) {
      alert("Signup ho gaya! Email verify kar ke login karo.");
      navigate("/login");
      return;
    }

    // ================= AFFILIATE LOGIC =================
    let affiliate_id = null;
    let ref_type = null;

    if (
      AFFILIATE_PARAMS.ref &&
      AFFILIATE_PARAMS.ref.startsWith("aff_")
    ) {
      affiliate_id = AFFILIATE_PARAMS.ref.replace("aff_", "");
      ref_type =
        AFFILIATE_PARAMS.type === "turnover"
          ? "turnover"
          : "revenue";
    }

    // ================= USERS DATA INSERT =================
    const { error: insertErr } = await supabase
      .from("users_data")
      .insert([
        {
          user_id: userId,
          affiliate_id,
          ref_type,
          ...defaultUserData
        }
      ]);

    if (insertErr) {
      alert("User data insert error: " + insertErr.message);
      return;
    }

    // ================= AFFILIATE TOTAL USERS UPDATE =================
    if (affiliate_id) {
      await supabase.rpc("affiliate_add_user", {
        aff_id: affiliate_id
      });
    }

    alert("Signup complete! Ab login karo.");
    navigate("/login");
  };

  return (
    <AuthWrapper>
      <form className="qx-card" onSubmit={handleSignup}>
        <h2 className="qx-title">Sign Up</h2>

        {/* ORIGINAL TABS – unchanged */}
        <div className="qx-tab-container">
          <Link to="/login" className="qx-tab">
            Login
          </Link>
          <button type="button" className="qx-tab active">
            Registration
          </button>
        </div>

        <input
          className="qx-input"
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <input
          className="qx-input"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <label className="qx-checkbox">
          <input type="checkbox" required /> I confirm I am 18+
        </label>

        <label className="qx-checkbox">
          <input type="checkbox" required /> I am not a US resident
        </label>

        <button type="submit" className="qx-btn">
          Create Account
        </button>
      </form>
    </AuthWrapper>
  );
}
